/**
 * Shared color palette for dashboard, navigation, and category theming.
 * Centralizes colors that were previously duplicated across NavRail and QuadrantLayout.
 */
export const categoryColors = {
    people: '#1976d2',
    corePlaces: '#388e3c',
    admin: '#d32f2f',
    toolsMeta: '#795548',
} as const;

/** Dashboard home button accent (brand orange). */
export const dashboardAccent = '#f7931e';

/** Quadrant category colors in display order (indices 0–3). */
export const quadrantCategoryColors = [
    categoryColors.people,
    categoryColors.corePlaces,
    categoryColors.admin,
    categoryColors.toolsMeta,
] as const;
